export async function shopRequest(path='', {method='GET',body,signal}={}) {
  const controller=new AbortController();
  const abort=()=>controller.abort();
  signal?.addEventListener('abort',abort,{once:true});
  if(signal?.aborted)controller.abort();
  const timer=setTimeout(abort,15000);
  try {
    const response=await fetch(`/api/${path}`,{method,credentials:'include',signal:controller.signal,headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    if(response.status===204)return null;
    const data=response.headers.get('content-type')?.includes('application/json')?await response.json():null;
    if(!response.ok){const error=Error(data?.error||'El servicio del catálogo no está disponible.');error.status=response.status;error.purchaseRejected=data?.compraRechazada===true;throw error;}
    if(!data)throw Error('La API no devolvió un catálogo válido.');
    return data;
  }finally{clearTimeout(timer);signal?.removeEventListener('abort',abort);}
}
